///include /assets/js/app/p/checkout.js
///include /assets/js/app/p/s-basket-service.js
///include /assets/js/app/p/spayment-item.js

"use strict"

class SBasketPaymentSelection {
    /**
     *
     * @param {boolean} with_implicit_items
     */
    constructor(with_implicit_items = true) {
        /** @type {SPaymentItem[]} */
        this.items = []
        this.withImplicitItems = with_implicit_items
    }
    get balance() {
        for(const item of this.items) {
            if(item instanceof SPaymentItemBalance) {
                return item
            }
        }
        return null
    }
    set balance(v) {
        this.items = this.items.filter(
            item => !(item instanceof SPaymentItemBalance)
        )
        if(v) this.items.push(v)
    }
    get card() {
        for(const item of this.items) {
            if(item instanceof SPaymentItemCard) {
                return item
            }
        }
        return null
    }
    set card(v) {
        this.items = this.items.filter(
            item => !(item instanceof SPaymentItemCard)
        )
        if(v) this.items.push(v)
    }
    get debit() {
        for(const item of this.items) {
            if(item instanceof SPaymentItemDirectDebit) {
                return item
            }
        }
        return null
    }
    set debit(v) {
        this.items = this.items.filter(
            item => !(item instanceof SPaymentItemDirectDebit)
        )
        if(v) this.items.push(v)
    }
    get implicitItems() {
        if(!Checkout.drivers) return null
        /**
         * @type {SPaymentItem[]}
         */
        const out = []
        for(const driver of Checkout.drivers) {
            if(!driver.requiresImmediateSelection) {
                for(const pt of driver.paymentTypes) {
                    out.push(
                        SPaymentItem.item({
                            //@ts-ignore
                            type: pt,
                            id: "",
                        })
                    )
                }
            }
        }
        return out
    }
    get paypal() {
        for(const item of this.items) {
            if(item instanceof SPaymentItemPayPal) {
                return item
            }
        }
        return null
    }
    set paypal(v) {
        this.items = this.items.filter(
            item => !(item instanceof SPaymentItemPayPal)
        )
        if(v) this.items.push(v)
    }
    get transfer() {
        for(const item of this.items) {
            if(item instanceof SPaymentItemTransfer) {
                return item
            }
        }
        return null
    }
    set transfer(v) {
        this.items = this.items.filter(
            item => !(item instanceof SPaymentItemTransfer)
        )
        if(v) this.items.push(v)
    }
    toJSON() {
        /**
         * @type {{[type: string]: string}}
         */
        const out = {}
        for(const item of this.items) {
            out[item.type] = item.ref
            for(const [atype, types] of SBasketService.realTypes.entries()) {
                if(types.includes(item.type)) {
                    out[atype] = item.ref
                }
            }
        }
        if(this.withImplicitItems && this.implicitItems) {
            for(const item of this.implicitItems) {
                out[item.type] = item.ref
            }
            for(const [atype, types] of SBasketService.realTypes.entries()) {
                if(!out[atype]) {
                    const item =
                        this.implicitItems.find(i => types.includes(i.type))
                    if(item) {
                        out[atype] = item.ref
                    }
                }
            }
        }
        return out
    }
}
